/**
 * The API answers 504 when the reporting engine has not finished a query
 * within its wait window. The engine keeps working on it and caches the
 * result, so asking again usually returns it. These helpers retry that case.
 */
export const isEngineTimeout = (err) => err?.response?.status === 504;

/**
 * Run `fn`, retrying up to `attempts` more times while the engine times out.
 * `onRetry(n)` is called before each retry.
 */
export async function withEngineRetry(fn, { attempts = 3, onRetry } = {}) {
  for (let attempt = 0; ; attempt += 1) {
    try {
      return await fn();
    } catch (err) {
      if (!isEngineTimeout(err) || attempt >= attempts) throw err;
      if (onRetry) onRetry(attempt + 1);
    }
  }
}
